import React, { useState } from 'react';
import { useMeasurement, useSirenEntity, muiTheme, generateClassName } from '~/utility/BinSentry-ui-utility';
import {
  Button,
  jssPreset,
  makeStyles,
  ThemeProviderV4,
  StyledEngineProvider,
  StylesProviderV4,
  ThemeProvider,
} from '~/lib/bn-material-ui';
import { create } from 'jss';
import ConsumptionRate from './consumption-rate/consumption-rate';
import UnmonitoredBanner from './banners/unmonitored';
import Graph from './graph';
import ManualBinLevel from '../../parcels/manual-bin-level/manual-bin-level';

const jss = create({ ...jssPreset() });

const useStyles = makeStyles((theme) => {
  return {
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      '& h3': {
        margin: '.5rem 0',
      },
    },
    inventory: {
      margin: '1rem 0 0 60px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'baseline',
      gap: '2rem',
      [theme.breakpoints.down('lg')]: {
        marginLeft: '0',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0',
      },
    },
    consumption: {
      display: 'flex',
      alignItems: 'baseline',
      '& span': {
        marginRight: '.5ch',
      },
    },
  };
});

export default function Unmonitored({ href, bin }) {
  const styles = useStyles();
  const [showConsumption, setShowConsumption] = useState(false);
  const [showManualInventory, setShowManualInventory] = useState(false);
  const [selectedLevelHref, setSelectedLevelHref] = useState(undefined);
  const { entity: binLevelsEntity } = useSirenEntity({ href: bin?.getSubEntity('https://api.binsentry.com/rel/v2/bin-levels')?.href });

  const { consumptionRate, bulkDensity } = bin?.properties || {};
  const measurement = useMeasurement({ name: 'orderAmount' });
  const dailyConsumption = `${measurement.convert({ volume: consumptionRate, bulkDensity }) || '-'} ${measurement.unit}/day`;

  return (
    <>
      <div className={styles.header}>
        <h3>Level History</h3>
      </div>
      <UnmonitoredBanner />
      <Graph
        href={href}
        onSelectManualBinLevel={(level) => {
          setSelectedLevelHref(level.id);
          setShowManualInventory(true);
        }}
      />
      <div className={styles.inventory}>
        {binLevelsEntity?.hasAction('create-bin-level') && (
          <Button variant='text' onClick={() => setShowManualInventory(true)}>
            Add Manual Inventory
          </Button>
        )}
        <div className={styles.consumption}>
          <span>Consumption Rate:</span>
          {bin?.hasAction('update-consumption-rate') ? (
            <Button variant='text' onClick={() => setShowConsumption(true)}>
              {dailyConsumption}
            </Button>
          ) : (
            <span>{dailyConsumption}</span>
          )}
        </div>
      </div>
      <StyledEngineProvider generateClassName={generateClassName} injectFirst>
        <StylesProviderV4 generateClassName={generateClassName} jss={jss}>
          <ThemeProvider theme={muiTheme}>
            <ThemeProviderV4 theme={muiTheme}>
              <ConsumptionRate
                href={href}
                oldRate={consumptionRate}
                bulkDensity={bulkDensity}
                handleClose={() => setShowConsumption(false)}
                show={showConsumption}
              />
              {showManualInventory &&
                <ManualBinLevel
                  show={showManualInventory}
                  handleClose={() => {
                    setSelectedLevelHref(undefined);
                    setShowManualInventory(false);
                  }}
                  href={href}
                  selectedLevelHref={selectedLevelHref}
                />
              }
            </ThemeProviderV4>
          </ThemeProvider>
        </StylesProviderV4>
      </StyledEngineProvider>
    </>
  );
}
